export default "__VITE_ASSET__EUieVT$O__"